import React from 'react';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';

const ColorButton = withStyles((theme) => ({
    root: {
      color: 'white',
      backgroundColor: props => props?.backgroundColor||'#ff2626',
      '&:hover': {
        backgroundColor: props => props?.backgroundColor||'#ff2626',
      },
      borderColor: 'white',
      borderWidth: '2px',
      border: 'solid',
      fontFamily: 'Kanit',
      padding: '5px 5px',
      fontSize: '0.8rem'
    },
}))(Button);

function ButtonContainer({text, onPress, bigText, mediumText, ...props}) {
  return (
    <ColorButton 
    {...props}
    onClick={onPress} 
    variant="contained"
    >
      <span className={bigText?"h2":mediumText?"h3":""}>{text}</span>
    </ColorButton>
  );
}

export default ButtonContainer;
